import { InputChoice } from 'components/formInputs/types';
import range from 'utils/range';

import { BasicsFormValues } from './types';

export const STATES = [
  { value: 1, label: 'Alabama' },
  { value: 2, label: 'Alaska' },
  { value: 3, label: 'Arizona' },
  { value: 4, label: 'Arkansas' },
  { value: 5, label: 'California' },
  { value: 6, label: 'Colorado' },
  { value: 7, label: 'Connecticut' },
  { value: 8, label: 'Delaware' },
  { value: 9, label: 'District Of Columbia' },
  { value: 10, label: 'Florida' },
  { value: 11, label: 'Georgia' },
  { value: 12, label: 'Hawaii' },
  { value: 13, label: 'Idaho' },
  { value: 14, label: 'Illinois' },
  { value: 15, label: 'Indiana' },
  { value: 16, label: 'Iowa' },
  { value: 17, label: 'Kansas' },
  { value: 18, label: 'Kentucky' },
  { value: 19, label: 'Louisiana' },
  { value: 20, label: 'Maine' },
  { value: 21, label: 'Maryland' },
  { value: 22, label: 'Massachusetts' },
  { value: 23, label: 'Michigan' },
  { value: 24, label: 'Minnesota' },
  { value: 25, label: 'Mississippi' },
  { value: 26, label: 'Missouri' },
  { value: 27, label: 'Montana' },
  { value: 28, label: 'Nebraska' },
  { value: 29, label: 'Nevada' },
  { value: 30, label: 'New Hampshire' },
  { value: 31, label: 'New Jersey' },
  { value: 32, label: 'New Mexico' },
  { value: 33, label: 'New York' },
  { value: 34, label: 'North Carolina' },
  { value: 35, label: 'North Dakota' },
  { value: 36, label: 'Ohio' },
  { value: 37, label: 'Oklahoma' },
  { value: 38, label: 'Oregon' },
  { value: 39, label: 'Pennsylvania' },
  { value: 40, label: 'Rhode Island' },
  { value: 41, label: 'South Carolina' },
  { value: 42, label: 'South Dakota' },
  { value: 43, label: 'Tennessee' },
  { value: 44, label: 'Texas' },
  { value: 45, label: 'Utah' },
  { value: 46, label: 'Vermont' },
  { value: 47, label: 'Virginia' },
  { value: 48, label: 'Washington' },
  { value: 49, label: 'West Virginia' },
  { value: 50, label: 'Wisconsin' },
  { value: 51, label: 'Wyoming' },
];

export const CORPORATE_STRUCTURES = [
  { label: 'C-corp', value: 'c_corp' },
  { label: 'S-corp', value: 's_corp' },
  { label: 'Limited Liability Corporation (LLC)', value: 'llc' },
  { label: 'Limited Liability Partnership (LLP)', value: 'llp' },
  { label: 'Professional Corporation (PC)', value: 'pc' },
  { label: 'Sole proprietorship', value: 'sole_proprietorship' },
];

export const OWNERSHIP_STAKES = range(0, 100).map((value) => ({
  label: `${value}%`,
  value,
}));

export const DISABILITY_INSURANCE_SOURCES = [
  { label: 'Covered by my employer', value: 'employer' },
  { label: 'Bought my own policy', value: 'own' },
  {
    label: 'I have both employer-provided coverage and a policy I bought myself',
    value: 'combo',
  },
];

export const INTEND_TO_REPLACE_OPTIONS: Array<InputChoice<string>> = [
  { label: 'Yes', value: 'true' },
  { label: 'No, this is supplementary coverage', value: 'false' },
];

export const LABELS: Record<keyof BasicsFormValues, string> = {
  gender: 'Gender',
  dateOfBirth: 'Date of birth',
  stateId: 'State',
  annualIncomeBeforeCompany: 'What was your annual income before you started this company?',
  atLeast30HoursAWeek: 'Do you work at least 30 hours / week in this occupation?',
  becameOwnerAt: 'Became owner/partner in',
  companyFoundedAt: 'Company founded in',
  corporateStructure: 'Corporate structure',
  disabilityInsuranceSource: 'What type of disability coverage do you have?',
  disabilityInsuranceStatus: 'Do you have existing coverage?',
  employerPaysPremium: 'Does your employer pay the insurance premium?',
  existingCoverage: 'Existing coverage (enter monthly benefit amount)',
  intendToReplace: 'Do you intend to replace your existing coverage?',
  job: "What's your occupation? (select the best match)",
  numberOfEmployees: 'Number of employees',
  numberOfPartners: 'Number of partners / co-owners',
  ownershipStake: 'What is your ownership stake?',
  selfEmployed: 'Are you self-employed or a business owner?',
};
